import script from "./RegisterInfo1.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterInfo1.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterInfo1.vue?vue&type=style&index=0&id=7c30a5c0&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c30a5c0"]])

export default __exports__